import { TenantSlug } from "../../sharedConfig.mjs";
import { CredentialVendor } from "../../credentialVendor.mjs";
import { skylightClinicConfig } from "./clinic.mjs";
import { skylightProviderRouting } from "./routing.mjs";

//#region src/tenants/skylight/index.ts
const skylight = {
	slug: TenantSlug.Skylight,
	displayName: "Skylight Medical Group",
	privacyPolicyUrl: "https://skylight.health/privacy-policy/",
	vendors: [
		CredentialVendor.Athena,
		CredentialVendor.Availity,
		CredentialVendor.Spruce
	],
	libretto: { workflows: {
		pullReferrals: { Athenahealth: "skylightAthenaPullOpenReferrals" },
		sendReferral: { Athenahealth: "skylightAthenaAttachRecordsSendReferral" },
		checkEligibility: { availity: "skylightAvailityCheckEligibility" },
		submitPriorAuth: { availity: "skylightAvailitySubmitPriorAuth" },
		recordPatientConsent: { Athenahealth: "skylightAthenaRecordPatientConsent" }
	} },
	clinic: skylightClinicConfig,
	routing: skylightProviderRouting,
	autoAssignReferralsToAgent: false,
	residentialProxy: {
		country: "US",
		state: "AZ",
		city: "phoenix"
	},
	auth: {
		sso: [{
			provider: "google",
			providerId: "skylight-google"
		}],
		password: true
	},
	spruce: {
		orgId: "entity_2PLJA21BKQG00",
		departmentEndpoints: { "Main Office": "ZW50aXR5XzJQTEpBMjFCS1FHMDA6KzE2MDI1ODQwMTQyOnBob25l" }
	}
};

//#endregion
export { skylight };